export default __webpack_public_path__ + "static/media/matthias-seitz.24b21072.png";